define('w3c/abstract',["exports", "core/pubsubhub", "core/l10n"], function (exports, _pubsubhub, _l10n) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.name = undefined;
  exports.run = run;
  // Module w3c/abstract
  // Handle the abstract section properly.
  const name = exports.name = "w3c/abstract";

  async function run() {
    const abs = document.getElementById("abstract");
    if (!abs) {
      (0, _pubsubhub.pub)("error", `Document must have one element with \`id="abstract"`);
      return;
    }
    abs.classList.add("introductory");
    let abstractHeading = document.querySelector("#abstract>h2");
    if (abstractHeading) {
      return;
    }
    abstractHeading = document.createElement("h2");
    abstractHeading.innerText = _l10n.l10n[_l10n.lang].abstract;
    abs.insertAdjacentElement("afterbegin", abstractHeading);
  }
});
//# sourceMappingURL=abstract.js.map;
